import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";

import Row from "../../common/grid/Row";
import Col from "../../common/grid/Col";
import SideBar from "./SideBar";
import Profile from "./profile/Profile";
import UserManagement from "./user-management/UserManagement";
import NewAddUser from "./user-management/add/newAddUser";
import EditUser from "./user-management/edit/EditUser";
import UserDetails from "./user-management/details/UserDetails.js";
import ProjectsIndex from "./projects/index/ProjectsIndex.js";
import Project from "./projects/project/Project.js";
import AddProject from "./projects/add/AddProject.js";
import EditProject from "./projects/edit/EditProject.js";
import Timesheet from "./timesheet/Timesheet";
import DonorsIndex from "./donors/index/DonorsIndex.js";
import AddDonor from "./donors/add/AddDonor.js";
import EditDonor from "./donors/edit/EditDonor.js";
import GfaDocumentsIndex from "./gfa-documents/index/GfaDocumentsIndex.js";
import AddGfaDocument from "./gfa-documents/add/AddGfaDocument.js";
import EditGfaDocument from "./gfa-documents/edit/EditGfaDocument.js";
import AddGfaFolder from "./gfa-documents/folders/add/AddGfaFolder.js";
import EditGfaFolder from "./gfa-documents/folders/edit/EditGfaFolder.js";
import LettersIndex from "./letters/index/LettersIndex.js";
import AddLetter from "./letters/add/AddLetter.js";
import EditLetter from "./letters/edit/EditLetter.js";
import AddLetterTemplate from "./letter-templates/add/AddLetterTemplate.js";
import EditLetterTemplate from "./letter-templates/edit/EditLetterTemplate.js";
import Calendar from "./calendar/Calendar.js";
import Files from "./files/Files.js";
import ModalWindowGroup from "../../common/chat/modalWindowGroup/modalWindowGroup.js";

// import AdminRoute from "../../common/router/AdminRoute.js";

import "./Main.css";

const Main = ({ match, user }) => {
	return (
		<div id="main">
			<SideBar match={match} />
			<Col main>
				<Row _space-between site-title>
					{/* <h1 className="no-word-wrap">Georgian Farmers Assosiation</h1> */}
					{/* <Row _no-grow>
            <h1>Eldocs.net</h1>
            <img src="/tree-logo.png" alt="GFA logo" className="logo"/>
            </Row> */}
					{/* <h1>Eldocs.net</h1> */}
					<div className="logoContainer">
						<img
							src="https://eldocs.net/eldocs-logo-dark.png"
							className="logo"
							alt="eldocs logo"
						/>
					</div>
				</Row>
				<Switch>
					<Route
						exact
						path={`${match.path}/`}
						render={props => {
							if (
								user.roles.filter(r => ["admin"].includes(r.name)).length > 0
							) {
								return <Redirect to={`${match.path}/projects`} />;
							} else {
								return <Redirect to={`${match.path}/timesheet`} />;
							}
						}}
					/>

					<Route
						exact
						path={`${match.path}/projects`}
						render={props => <ProjectsIndex {...props} />}
					/>
					<Route
						path={`${match.path}/projects/add`}
						render={props => <AddProject />}
					/>
					<Route
						path={`${match.path}/projects/:id/edit`}
						render={props => <EditProject {...props} />}
					/>
					<Route
						path={`${match.path}/projects/:id`}
						render={props => <Project {...props} />}
					/>

					<Route
						exact
						path={`${match.path}/donors`}
						render={props => <DonorsIndex {...props} />}
					/>
					<Route
						path={`${match.path}/donors/add`}
						render={props => <AddDonor {...props} />}
					/>
					<Route
						path={`${match.path}/donors/:id/edit`}
						render={props => <EditDonor {...props} />}
					/>

					<Route
						path={`${match.path}/user-management`}
						render={props => <UserManagement />}
					/>
					<Route path={`${match.path}/profile`} render={props => <Profile />} />
					<Route
						path={`${match.path}/users/add`}
						render={props => <NewAddUser />}
					/>
					<Route
						path={`${match.path}/users/:id/edit`}
						render={props => <EditUser {...props} />}
					/>
					<Route
						path={`${match.path}/users/:id/details`}
						render={props => <UserDetails {...props} />}
					/>

					<Route
						path={`${match.path}/calendar/:entryId?`}
						render={props => <Calendar {...props} />}
					/>
					<Route
						path={`${match.path}/timesheet`}
						render={props => <Timesheet />}
					/>
					<Route path={`${match.path}/files`} render={props => <Files />} />

					<Route
						exact
						path={`${match.path}/gfa-documents`}
						render={props => <GfaDocumentsIndex {...props} />}
					/>
					<Route
						path={`${match.path}/gfa-documents/add`}
						render={props => <AddGfaDocument {...props} />}
					/>
					<Route
						path={`${match.path}/gfa-documents/:id/edit`}
						render={props => <EditGfaDocument {...props} />}
					/>
					<Route
						path={`${match.path}/folders/add`}
						render={props => <AddGfaFolder {...props} />}
					/>
					<Route
						path={`${match.path}/folders/:id/edit`}
						render={props => <EditGfaFolder {...props} />}
					/>

					<Route
						exact
						path={`${match.path}/letters`}
						render={props => <LettersIndex {...props} />}
					/>
					<Route
						path={`${match.path}/letters/add`}
						render={props => <AddLetter {...props} />}
					/>
					<Route
						path={`${match.path}/letters/:id/edit`}
						render={props => <EditLetter {...props} />}
					/>

					<Route
						path={`${match.path}/letter-templates/add`}
						render={props => <AddLetterTemplate {...props} />}
					/>
					<Route
						path={`${match.path}/letter-templates/:id/edit`}
						render={props => <EditLetterTemplate {...props} />}
					/>
				</Switch>
				<ModalWindowGroup />
			</Col>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		user: state.auth.currentUser
	};
};

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/main/Main.js